import { render, staticRenderFns } from "./LangSelect.vue?vue&type=template&id=d3a522f4"
import script from "./LangSelect.vue?vue&type=script&lang=ts"
export * from "./LangSelect.vue?vue&type=script&lang=ts"
import style0 from "./LangSelect.vue?vue&type=style&index=0&id=d3a522f4&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports